import React, { useEffect } from "react";
import "./style.scss";

import Card from "../../../../reusableComponents/Card";
import { convertSnakeCaseToDefault } from "../../../../utils/helpers/string";

function TierHeader({ tier }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  

  const formattedTitles = [
    // "leverage",
    "leverage(FX)",
    "leverage(Crypto)",
    "max_daily_loss",
    "max_loss (Trailing)",
    "min_trading_days",
    "profit_target_1",
    // "profit_target_2",
    "profit_share",
    "starting_balance",
    // "EAS",
    "Tradable Asset",
    "Trade through News",
    "Hold over the Weekend",
    "Hedging & Stacking",
  ];

  if (tier && tier[0]?.name === "2 Step") {
    // Add 'profit_target_2' at the 6th index
    formattedTitles.splice(6, 0, "profit_target_2");

    // Replace 'max_loss (Trailing)' with 'max_loss'
    const index = formattedTitles.indexOf("max_loss (Trailing)");
    if (index !== -1) {
      formattedTitles[index] = "max_loss";
    }
  }
  const instant_funding = tier && tier?.some((item) => item.id === 13);

  return (
    <Card className="tierheader-container">
      {formattedTitles?.map((item, index) => (
        <p
          style={{ height: index === 0 ? "91px" : "" }}
          key={index}
        >
          {item === "ea" ? "EA" : convertSnakeCaseToDefault(item)}
        </p>
      ))}
    </Card>
  );
}

export default TierHeader;
